import { ClassAttributes, ImgHTMLAttributes, useState } from 'react'
import { ExtraProps } from 'react-markdown'
import { PhotoProvider, PhotoView } from 'react-photo-view'
import 'react-photo-view/dist/react-photo-view.css'
import { IoMdDownload } from '@react-icons/all-files/io/IoMdDownload'

type Props = ClassAttributes<HTMLImageElement> & ImgHTMLAttributes<HTMLImageElement> & ExtraProps

export function Img({ src, alt, ...props }: Props) {
  const downloadFileName = 'diagram.png'
  const [isHovered, setIsHovered] = useState(false)
  return (
    <PhotoProvider maskOpacity={0.8} bannerVisible={false}>
      <div
        className='relative mt-3 border border-gray-300 rounded max-w-full w-fit'
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <PhotoView src={src}>
          <img
            aria-label='image'
            className='max-w-full h-auto cursor-pointer rounded'
            src={src}
            alt={alt}
            {...props}
          />
        </PhotoView>
        {isHovered ? (
          <a
            href={src}
            download={downloadFileName}
            className='absolute top-2 right-2 bg-slate-300 text-white p-1 rounded hover:bg-slate-400'
            aria-label='Download image'
          >
            <IoMdDownload size={20} />
          </a>
        ) : null}
      </div>
    </PhotoProvider>
  )
}
